import { without as _without } from 'lodash';

class WebEnquiriesController {
  constructor(authService, userService, loadingService, $scope, webEnquiriesService, $state, $ngConfirm, growl, pushService, $filter, enums) {
    "ngInject";

    this.authService = authService;
    this.userService = userService;
    this.loadingService = loadingService;
    this.$scope = $scope;
    this.webEnquiriesService = webEnquiriesService;
    this.$state = $state;
    this.$ngConfirm = $ngConfirm;
    this.growl = growl;
    this.pushService = pushService;
    this.$filter = $filter;
    this.enums = enums;

    this.pagination = {
      totalItems: 0,
      currentPage: 1,
      pageSize: 10
    };    

    this.webEnquiries = [];

    $scope.$on('dashboard:viewWebEnquiriesStats', this.loadStats.bind(this));
    $scope.$on('dashboard:viewWebEnquiries', this.viewWebEnquiries.bind(this));
  }

  loadStats(evt, params) {    
    const ctrl = this;

    ctrl.loadingService.showLoading('vehiclesList', 'Loading Enquiries');

    ctrl.userService.webEnquiriesStats(ctrl.authService.authData.currentLocation.key)
      .then(response => {        
        ctrl.pagination.totalItems = response.data;
        ctrl.onLoadStats({count: response.data});
      })
      .finally(() => {
        ctrl.loadingService.hideLoading('vehiclesList');
      });
  }  

  viewWebEnquiries(evt) {
    //Toggle Event coming from dashboard instead of page change, skip the method
    if (evt && this.webEnquiries.length){
      return;
    }        

    const ctrl = this;

    ctrl.loadingService.showLoading('vehiclesList', 'Loading Enquiries');

    ctrl.userService.webEnquiries(ctrl.authService.authData.currentLocation.key, this.pagination.currentPage)
      .then(response => {
        ctrl.webEnquiries = response.data;
      })
      .finally(() => {
        ctrl.loadingService.hideLoading('vehiclesList');
      });
  }

  acceptConfirm(webEnquiryId) {    
    this.$ngConfirm({
      title: false,
      content: `Are you sure you want to accept this enquiry ?`,
      typeAnimation: false,
      columnClass: 'm',
      buttons: {
          yes: {
              text: 'Accept',
              btnClass: 'btn-primary',
              action: () => { this.createEnquiry(webEnquiryId, this.authService.authData.userId, false); }
          },
          no: {
            text: 'Not Sure',
            btnClass: 'btn-default'
          }          
      }      
    }); 
  }

  assignConfirm(webEnquiryId, source, confirm) {
    if (!confirm && source === this.enums.WEB_ENQUIRY_SOURCE.Codeweavers) {
      this.getCodeweaversData(webEnquiryId);
      return;
    }

    this.$scope.locationUsers = this.locationUsers;
    this.$scope.selectedUser = this.locationUsers[0];
    this.$scope.selectedUser.firstName = 'Please Select';

    this.$ngConfirm({
      title: 'Assign Enquiry',
      contentUrl: `templates/webEnquiry/assignWebEnquiry`,
      typeAnimation: false,
      columnClass: 'm',
      scope: this.$scope,
      buttons: {
        yes: {
            text: 'Assign',
            btnClass: 'btn-primary',
            action: () => { 
              if (this.$scope.selectedUser.userId) {
                this.createEnquiry(webEnquiryId, this.$scope.selectedUser.userId, true);
              }              
              else {
                return false;
              }              
            }
        },
        no: {
          text: 'Cancel',
          btnClass: 'btn-default'
        }          
    }
    }); 
  }

  createEnquiry(webEnquiryId, assignedTo, assignedByManager) {
    const ctrl = this;

    ctrl.loadingService.showLoading('vehiclesList', 'Loading Enquiries');

    ctrl.webEnquiriesService.createEnquiry(webEnquiryId, assignedTo)
      .then(response => {
        if (!assignedByManager)
        {
          this.$state.go('enquiryEdit', {enquiryId: response.data});
        }        
        else{
          this.growl.success(`Enquiry created successfully and has been assigned to ${this.$scope.selectedUser.firstName} ${this.$scope.selectedUser.lastName}`, {ttl: 5000});
          this.removeEnquiryAndUpdateCount(webEnquiryId);
          if (assignedTo != this.authService.authData.userId) {
            this.pushService.messageHub.enquiryCreatedFromWebEnquiry(assignedTo,response.data,this.authService.loggedInUserName());
          }          
        }
      })
      .catch(err => {
        this.growl.error(`An error occurred while creating enquiry`, {ttl: 5000});
      })
      .finally(() => {
        ctrl.loadingService.hideLoading('vehiclesList');
      });
  }

  deleteConfirm(webEnquiryId) {
    this.$ngConfirm({
      title: false,
      content: `Are you sure you want to reject this enquiry ?`,
      typeAnimation: false,
      columnClass: 'm',
      buttons: {
        yes: {
            text: 'Yes',
            btnClass: 'btn-primary',
            action: () => { this.deleteEnquiry(webEnquiryId); }
        },
        no: {
          text: 'Not Sure',
          btnClass: 'btn-default'
        }          
    }
    }); 
  }  

  deleteEnquiry(webEnquiryId) {
    const ctrl = this;

    ctrl.loadingService.showLoading('vehiclesList', 'Loading Enquiries');

    ctrl.webEnquiriesService.deleteEnquiry(webEnquiryId)
      .then(response => {
          this.growl.success(`Enquiry rejected successfully`, {ttl: 5000});
          this.removeEnquiryAndUpdateCount(webEnquiryId);
      })
      .catch(err => {
        this.growl.error(`An error occurred while rejecting enquiry`, {ttl: 5000});
      })
      .finally(() => {
        ctrl.loadingService.hideLoading('vehiclesList');
      });
  }  

  removeEnquiryAndUpdateCount(webEnquiryId){
    const webEnquiry = this.webEnquiries.find(we => we.webEnquiryId === webEnquiryId)
    this.webEnquiries = _without(this.webEnquiries, webEnquiry);            
    this.onLoad({count: this.webEnquiries.length});
  }
  
  getTestDriveDate(we) {
    if (we.additionalData) {
      const data = JSON.parse(we.additionalData);

      if (data.testDriveTime){
        return this.$filter('date')(new Date(data.testDriveTime), 'dd MMM yyyy HH:mm');
      }
    }
  }

  getCodeweaversData(webEnquiryId) {
    const ctrl = this;

    ctrl.loadingService.showLoading('vehiclesList', 'Getting Data');

    ctrl.webEnquiriesService.getCodeweaversData(webEnquiryId)
      .then(response => {
        ctrl.$scope.data = response.data;
    
        this.$ngConfirm({
          title: 'Review Enquiry Data',
          contentUrl: `templates/webEnquiry/codeweaversDataTemplate`,
          typeAnimation: false,
          columnClass: 'l',
          scope: this.$scope,
          buttons: {
            yes: {
                text: 'Go To Assign',
                btnClass: 'btn-primary',
                action: () => { 
                  ctrl.assignConfirm(webEnquiryId, ctrl.enums.WEB_ENQUIRY_SOURCE.Codeweavers, true);                  
                }
            },
            no: {
              text: 'Cancel',
              btnClass: 'btn-default'
            }          
        }
        }); 
      })
      .catch(err => {
        this.growl.error(`An error occurred while creating enquiry`, {ttl: 5000});
      })
      .finally(() => {
        ctrl.loadingService.hideLoading('vehiclesList');
      });
  }
}

export default WebEnquiriesController;



// WEBPACK FOOTER //
// ./client/app/components/dashboard/webEnquiries/webEnquiries.controller.js